import { Divider, Grid, useTheme } from "@mui/material";
import { TitledSection } from "components/Classifiers/Common/TitledSection";
import { answerColorToThemeColor } from "components/Evaluation/Utils";
import React from "react";
import { SuccessfulResult } from "./SuccessfulResult";
import { useStore } from "utils/useStore";
import { TestLLMClassifierAgreementResult } from "models/LLMs/Testing/TestLLMClassifierAgreementResult";
import { LLMClassifierBuilderStore } from "components/Classifiers/LLMClassifiers/Stores/LLMClassifierBuilderStore";
import { ResultBadge } from "../ResultBadge";
import { getFriendlyId } from "../utils";

interface SuccessfulResultsSectionProps {
    results: TestLLMClassifierAgreementResult[];
    label: string;
}

export function SuccessfulResultsSection({
    results,
    label,
}: SuccessfulResultsSectionProps) {
    const theme = useTheme();
    const store = useStore(LLMClassifierBuilderStore);

    return (
        <TitledSection
            id={getFriendlyId(label)}
            title={
                <ResultBadge color={store.getResultColor(label)}>
                    {label} ({results.length})
                </ResultBadge>
            }
            variant="bordered"
            collapsible
            sx={{
                borderLeft: `4px solid ${
                    answerColorToThemeColor(theme, store.getResultColor(label))
                        .borderColor
                }`,
            }}
        >
            {results.length > 0 && (
                <Grid container direction="column" flexWrap="nowrap" rowGap={2}>
                    {results.map((result, number) => (
                        <React.Fragment key={result.conversation.id}>
                            <SuccessfulResult result={result} number={number} />
                            {number !== results.length - 1 && <Divider />}
                        </React.Fragment>
                    ))}
                </Grid>
            )}
        </TitledSection>
    );
}
